export class ProposalPaymentDO {

    public paymentFrequencyCd: String = null;
    public getpaymentFrequencyCd(): String {
        return this.paymentFrequencyCd;
    }
    public setpaymentFrequencyCd(value: String) {
        this.paymentFrequencyCd = value;
    }

    public accountHolderName: String = null;
    public getaccountHolderName(): String {
        return this.accountHolderName;
    }
    public setaccountHolderName(value: String) {
        this.accountHolderName = value;
    }

    public accountNum: Number = null;
    public getaccountNum(): Number {
        return this.accountNum;
    }
    public setaccountNum(value: Number) {
        this.accountNum = value;
    }

    public paymentMethodCd: String = null;
    public getpaymentMethodCd(): String {
        return this.paymentMethodCd;
    }
    public setpaymentMethodCd(value: String) {
        this.paymentMethodCd = value;
    }

    public branchIdNum1: String = null;
    public getbranchIdNum1(): String {
        return this.branchIdNum1;
    }
    public setbranchIdNum1(value: String) {
        this.branchIdNum1 = value;
    }

    public branchIdNum2: Number = null;
    public getbranchIdNum2(): Number {
        return this.branchIdNum2;
    }
    public setbranchIdNum2(value: Number) {
        this.branchIdNum2 = value;
    }

    public bankName: String = null;
    public getbankName(): String {
        return this.bankName;
    }
    public setbankName(value: String) {
        this.bankName = value;
    }

    public bankBranchName: String = null;
    public getbankBranchName(): String {
        return this.bankBranchName;
    }
    public setbankBranchName(value: String) {
        this.bankBranchName = value;
    }

    public accountTypeCd: String = null;
    public getaccountTypeCd(): String {
        return this.accountTypeCd;
    }
    public setaccountTypeCd(value: String) {
        this.accountTypeCd = value;
    }
}